import { render, staticRenderFns } from "./StepContent.vue?vue&type=template&id=089d67d4&scoped=true&"
import script from "./StepContent.vue?vue&type=script&lang=js&"
export * from "./StepContent.vue?vue&type=script&lang=js&"
import style0 from "./StepContent.vue?vue&type=style&index=0&id=089d67d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d67d4",
  null
  
)

export default component.exports